import { DesignEntity, PolicyLevel } from '@/lib/enums';

const getInitialRoles = () => ({
  [DesignEntity.ORGANISATION]: {
    byId: {},
    byRole: {
      [PolicyLevel.ADMIN]: new Set(),
      [PolicyLevel.BUDGET]: new Set(),
      [PolicyLevel.EDITOR]: new Set(),
      [PolicyLevel.VIEWER]: new Set(),
    },
  },
  [DesignEntity.DESIGN]: {
    byId: {},
    byRole: {
      [PolicyLevel.ADMIN]: new Set(),
      [PolicyLevel.EDITOR]: new Set(),
      [PolicyLevel.VIEWER]: new Set(),
    },
  },
  [DesignEntity.GROUP]: {
    byId: {},
    byRole: {
      [PolicyLevel.SUPPORTER]: new Set(),
    },
  },
});

/**
 * Retrieve RBAC roles for the current user.
 * The return object is keyed by entity type (e.g. DESIGN)
 * with each value being an object with two keys:
 * - byId: a map of entity ids to role levels
 * - byRole: a map of role levels to entity ids
 *
 * Example: roles.DESIGN.byId['123'] === 'admin'
 *
 * @param {Object} me
 * @return {Object}
 */
export default function getRoles(me) {
  const roles = getInitialRoles();
  if (!me?.access?.roles) {
    return roles;
  }

  for (const context in me?.access?.roles) {
    me.access.roles[context].forEach((role) => {
      const [lowerType, level, id] = role.split('.');
      const type = lowerType.toUpperCase();
      roles[type].byId[id] = level;
      roles[type].byRole[level].add(id);
    });
  }

  return roles;
}
